import { Controller } from '@hotwired/stimulus'
import { prefersReducedMotion } from '../utils/document'

export default class extends Controller {
  static targets = ['slide']
  static classes = ['active']
  static values = { interval: { type: Number, default: 3000 } }

  connect() {
    if (prefersReducedMotion() || this.slideTargets.length < 2) return

    this.index = Math.max(this.slideTargets.findIndex((s) => s.classList.contains(this.activeClass)), 0)
    this.timer = setInterval(() => this.#advance(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  #advance() {
    this.slideTargets[this.index].classList.remove(this.activeClass)
    this.index = (this.index + 1) % this.slideTargets.length
    this.slideTargets[this.index].classList.add(this.activeClass)
  }
}
